import { Blocs } from '@business/blocs';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';

export class ServiceProviderPageBloc extends BaseBloc {
  private readonly tmServiceProviderBloc = resolve(Blocs.tmServiceProvider);

  regions$ = this.tmServiceProviderBloc.items$;

  onInit() {
    return this.tmServiceProviderBloc.fetchServiceProviders();
  }

  createServiceProvider = this.tmServiceProviderBloc.createServiceProvider;
  updateServiceProvider = this.tmServiceProviderBloc.updateServiceProvider;
  deleteServiceProvider = this.tmServiceProviderBloc.deleteServiceProvider;
}
